export const core = {
  blur: {},
  borders: {
    base: `1px solid #CBD5E0`,
  },
  breakpoints: {
    base: `90em`,
    sm: `30em`,
    md: `48em`,
    lg: `62em`,
    xl: `90em`,
    '2xl': `100em`,
  },
  colors: {
    whiteAlpha: {
      10: `hsl(0 0% 98% / 0.1)`,
      50: `hsl(0 0% 98% / 0.04)`,
      100: `hsl(0 0% 98% / 0.06)`,
      200: `hsl(0 0% 98% / 0.08)`,
      300: `hsl(0 0% 98% / 0.16)`,
      400: `hsl(0 0% 98% / 0.24)`,
      500: `hsl(0 0% 98% / 0.36)`,
      600: `hsl(0 0% 98% / 0.48)`,
      700: `hsl(0 0% 98% / 0.64)`,
      800: `hsl(0 0% 98% / 0.8)`,
      900: `hsl(0 0% 98% / 0.92)`,
    },
    blackAlpha: {
      50: `rgba(0, 0, 0, 0.04)`,
      100: `rgba(0, 0, 0, 0.06)`,
      200: `rgba(0, 0, 0, 0.08)`,
      300: `rgba(0, 0, 0, 0.16)`,
      400: `rgba(0, 0, 0, 0.24)`,
      500: `rgba(0, 0, 0, 0.36)`,
      600: `rgba(0, 0, 0, 0.48)`,
      700: `rgba(0, 0, 0, 0.64)`,
      800: `rgba(0, 0, 0, 0.80)`,
      900: `rgba(0, 0, 0, 0.92)`,
    },
    green: {
      50: `#F0FFF4`,
      100: `#C6F6D5`,
      200: `#9AE6B4`,
      300: `#68D391`,
      400: `#48BB78`,
      500: `#38A169`,
      600: `#2F855A`,
      700: `#276749`,
      800: `#22543D`,
      900: `#1C4532`,
    },
    red: {
      50: `#FFF5F5`,
      100: `#FED7D7`,
      200: `#FEB2B2`,
      300: `#FC8181`,
      400: `#F56565`,
      500: `#E53E3E`,
      600: `#C53030`,
      700: `#9B2C2C`,
      800: `#822727`,
      900: `#63171B`,
    },
    purple: {
      50: `#FAF5FF`,
      100: `#E9D8FD`,
      200: `#D6BCFA`,
      300: `#B794F4`,
      400: `#9F7AEA`,
      500: `#805AD5`,
      600: `#6B46C1`,
      700: `#553C9A`,
      800: `#44337A`,
      900: `#322659`,
    },
    teal: {
      50: `#E6FFFA`,
      100: `#B2F5EA`,
      200: `#81E6D9`,
      300: `#4FD1C5`,
      400: `#38B2AC`,
      500: `#319795`,
      600: `#2C7A7B`,
      700: `#285E61`,
      800: `#234E52`,
      900: `#1D4044`,
    },
    gray: {
      50: `#F7FAFC`,
      100: `#EDF2F7`,
      200: `#E2E8F0`,
      300: `#CBD5E0`,
      400: `#A0AEC0`,
      500: `#718096`,
      600: `#4A4A4A`,
      700: `#2D3748`,
      800: `#1A202C`,
      900: `#171923`,
    },
    orange: {
      50: `#FFFAF0`,
      100: `#FEEBC8`,
      200: `#FBD38D`,
      300: `#F6AD55`,
      400: `#ED8936`,
      500: `#DD6B20`,
      600: `#C05621`,
      700: `#9C4221`,
      800: `#7B341E`,
      900: `#652B19`,
    },
    yellow: {
      50: `#FFFFF0`,
      100: `#FEFCBF`,
      200: `#FAF089`,
      300: `#F6E05E`,
      400: `#ECC94B`,
      500: `#D69E2E`,
      600: `#B7791F`,
      700: `#975A16`,
      800: `#744210`,
      900: `#52340F`,
    },
    cyan: {
      50: `#EDFDFD`,
      100: `#C4F1F9`,
      200: `#9DECF9`,
      300: `#76E4F7`,
      400: `#0BC5EA`,
      500: `#00B5D8`,
      600: `#00A3C4`,
      700: `#0987A0`,
      800: `#086F83`,
      900: `#065666`,
    },
    pink: {
      50: `#FFF5F7`,
      100: `#FED7E2`,
      200: `#FBB6CE`,
      300: `#F687B3`,
      400: `#ED64A6`,
      500: `#D53F8C`,
      600: `#B83280`,
      700: `#97266D`,
      800: `#702459`,
      900: `#521B41`,
    },
    Primary: {
      50: `#d2f0fe`,
      100: `#a0dffd`,
      200: `#87d7fd`,
      300: `#6ecefc`,
      400: `#55c6fc`,
      500: `#23B5FB`,
      600: `#049de7`,
      700: `#048cce`,
      800: `#037bb5`,
    },
    lightBlue: {
      100: `#f6f8fc`,
      200: `#eaf1fb`,
      300: `#23B5FB`,
    },
    blue: {
      50: `#e8f2ff`,
      100: `#d1e4ff`,
      200: `#a2c9ff`,
      300: `#73adff`,
      400: `#4299e1`,
      500: `#4090ff`,
      600: `#076eff`,
      700: `#0056d0`,
      800: `#00419d`,
      900: `#002d6d`,
      1000: `#002d6d`,
    },
    white: `#fafafa`,
    whitest: `#fff`,
    black: `#050505`,
    transparent: `transparent`,
  },
  direction: `ltr`,
  fonts: {
    inter: `var(--font-inter), Inter, sans-serif`,
  },
  fontSizes: {
    [`2xs`]: `0.625rem`,
    xs: `0.625rem`,
    sm: `0.75rem`,
    md: `0.875rem`,
    lg: `1rem`,
    xl: `1.25rem`,
    xxl: `1.5rem`,
  },
  fontWeights: {
    normal: `400`,
    medium: `500`,
  },
  letterSpacings: {},
  lineHeights: {
    shorter: `1.25`,
    none: `1`,
    normal: `normal`,
    taller: `2.5`,
    tallest: `3`,
  },
  radii: {
    sm: `3px`,
    md: `6px`,
    lg: `10px`,
    full: `10000px`,
    none: `0`,
  },
  shadows: {
    lg: `0px 10px 40px -10px hsl(200 96.6% 46.1% / 0.5)`,
    md: `0px 5px 20px -5px hsl(200 96.6% 46.1% / 0.5)`,
    sm: `0px 1px 3px -2px hsl(200 96.6% 46.1% / 0.5)`,
  },
  sizes: {
    16: `1rem`,
    20: `1.25rem`,
    24: `1.5rem`,
    28: `1.75rem`,
    32: `2rem`,
    36: `2.25rem`,
    40: `2.5rem`,
    48: `3rem`,
    60: `3.75rem`,
    80: `5rem`,
  },
  space: {
    1: `unset`,
    2: `0.125rem`,
    3: `unset`,
    4: `0.25rem`,
    5: `unset`,
    6: `unset`,
    7: `unset`,
    8: `0.5rem`,
    9: `unset`,
    10: `unset`,
    12: `0.75rem`,
    14: `unset`,
    16: `1rem`,
    18: `unset`,
    20: `1.25rem`,
    22: `unset`,
    24: `1.5rem`,
    26: `unset`,
    28: `1.75rem`,
    30: `unset`,
    32: `2rem`,
    34: `unset`,
    36: `2.25rem`,
    38: `unset`,
    40: `2.5rem`,
    42: `unset`,
    44: `2.75rem`,
    46: `unset`,
    48: `3rem`,
    50: `unset`,
    52: `3.25rem`,
    54: `unset`,
    56: `3.5rem`,
    58: `unset`,
    60: `3.75rem`,
    62: `unset`,
    64: `4rem`,
    66: `unset`,
    68: `unset`,
    70: `unset`,
    72: `4.5rem`,
    74: `unset`,
    76: `unset`,
    78: `unset`,
    80: `5rem`,
    82: `unset`,
    84: `unset`,
    96: `6rem`,
  },
  transition: {},
  zIndices: {},
};

export type CoreTheme = typeof core;

export const semantic = {
  colors: {
    intent: {
      success: `green.300`,
      warn: `orange.300`,
      danger: `red.300`,
      info: `blue.300`,
    },
    brand: {
      light: `Primary.600`,
      dark: `Primary.600`,
      lighter: `hsl(199 95.9% 63.9%)`,
      lightAlpha: `hsl(200 96.6% 46.1% / 0.5)`,
      'lightAlpha.25': `hsl(200 96.6% 46.1% / 0.25)`,
    },
    text: {
      base: `black`,
      inverse: `white`,
      muted: `gray.600`,
      link: `brand.light`,
    },
    background: {
      canvas: `lightBlue.200`,
      body: `#fafafa`,
      surface: `white`,
      overlay: `whitest`,
    },
    border: `gray.300`,
    'admin-badge': `brand.danger.500`,
  },
  fontSizes: {
    body: `0.875rem`,
    title: `1.25rem`,
  },
  fonts: {
    heading: `var(--font-inter), Inter, sans-serif`,
    body: `var(--font-inter), Inter, sans-serif`,
  },
  breakpoints: {
    desktop: `90em`,
  },
  elevation: {
    _hover: `0px 1px 3px -2px hsl(200 96.6% 46.1% / 0.5)`,
    popover: `0px 5px 20px -5px hsl(200 96.6% 46.1% / 0.5)`,
  },
};

export type SemanticTheme = typeof semantic;

export const semanticWithCSS = {
  colors: {
    intent: {
      success: `green.300`,
      warn: `orange.300`,
      danger: `red.300`,
      info: `blue.300`,
    },
    brand: {
      light: `Primary.600`,
      dark: `Primary.600`,
      lighter: `hsl(199 95.9% 63.9%)`,
      lightAlpha: `hsl(200 96.6% 46.1% / 0.5)`,
      'lightAlpha.25': `hsl(200 96.6% 46.1% / 0.25)`,
    },
    text: {
      base: `black`,
      inverse: `white`,
      muted: `gray.600`,
      link: `brand.light`,
    },
    background: {
      canvas: `lightBlue.200`,
      body: `#fafafa`,
      surface: `white`,
      overlay: `whitest`,
    },
    border: `gray.300`,
  },
  fontSizes: {
    body: `0.875rem`,
    title: `1.25rem`,
  },
  fonts: {
    heading: `var(--font-inter), Inter, sans-serif`,
    body: `var(--font-inter), Inter, sans-serif`,
  },
  breakpoints: {
    desktop: `90em`,
  },
  elevation: {
    _hover: `0px 1px 3px -2px hsl(200 96.6% 46.1% / 0.5)`,
    popover: `0px 5px 20px -5px hsl(200 96.6% 46.1% / 0.5)`,
  },
};

export type SemanticwithcssTheme = typeof semanticWithCSS;

export const components = {
  Tag: {
    bgColor: {
      base: `var(--linx-colors-gray-400)`,
    },
    radii: {
      base: `var(--linx-radii-lg)`,
    },
    lineHeights: {
      sm: `var(--linx-lineHeights-none)`,
    },
  },
  ContextMenu: {
    baseStyle: {
      bgColor: `var(--linx-colors-background-surface)`,
      boxShadow: `var(--linx-elevation-popover)`,
      radii: `var(--linx-radii-lg)`,
      padding: `var(--linx-space-4)`,
    },
  },
  PaginationContainer: {
    baseStyle: {
      gap: `var(--linx-space-4)`,
      color: `var(--linx-colors-text-muted)`,
    },
  },
  PaginationButton: {
    baseStyle: {
      border: `var(--linx-borders-base)`,
    },
    _active: {
      _active: {
        color: `var(--linx-colors-text-link)`,
      },
    },
  },
  IconButton: {
    baseStyle: {
      minWidth: `var(--linx-sizes-32)`,
      minHeight: `var(--linx-sizes-32)`,
      maxHeight: `var(--linx-sizes-32)`,
    },
  },
  ContextMenuItem: {
    baseStyle: {
      fontSizes: `var(--linx-fontSizes-sm)`,
      radii: `var(--linx-radii-lg)`,
      paddingInlineStart: `var(--linx-space-8)`,
      paddingInlineEnd: `var(--linx-space-8)`,
      paddingTop: `var(--linx-space-4)`,
      paddingBottom: `var(--linx-space-4)`,
    },
    default: {
      _hover: {
        bgColor: `var(--linx-colors-gray-50)`,
      },
    },
  },
  ContextMenuItemIcon: {
    baseStyle: {
      fontSizes: `var(--linx-fontSizes-sm)`,
    },
  },
  Text: {
    fontSizes: {
      base: `var(--linx-fontSizes-md)`,
      xs: `var(--linx-fontSizes-xs)`,
      sm: `var(--linx-fontSizes-sm)`,
      md: `var(--linx-fontSizes-md)`,
      lg: `var(--linx-fontSizes-lg)`,
      xl: `var(--linx-fontSizes-xl)`,
    },
  },
  Stepper: {
    default: {
      color: `var(--linx-colors-text-base)`,
    },
  },
  Button: {
    md: {
      paddingInlineStart: `var(--linx-space-16)`,
      paddingInlineEnd: `var(--linx-space-16)`,
    },
    filled: {
      border: `1px solid transparent`,
      bgColor: `var(--linx-colors-brand-light)`,
      color: `var(--linx-colors-text-inverse)`,
      _hover: {
        bgColor: `hsl(200 96.6% 51.5%)`,
      },
      _active: {
        bgColor: `hsl(200 96.6% 36.9%)`,
        color: `hsl(0 0% 88.2%)`,
      },
      _disabled: {
        bgColor: `var(--linx-colors-gray-400)`,
        color: `hsl(0 0% 98.2%)`,
      },
    },
    tinted: {
      bgColor: `hsl(200 96.6% 46.1% / 0.1)`,
      color: `var(--linx-colors-brand-light)`,
      _hover: {
        boxShadow: `var(--linx-elevation-_hover)`,
        bgColor: `hsl(199 96.7% 80.9%)`,
        color: `var(--linx-colors-Primary-600)`,
      },
      _active: {
        bgColor: `hsl(200 96.6% 62.3%)`,
        color: `hsl(0 0% 88.2%)`,
        _hover: `none`,
      },
      _disabled: {
        bgColor: `var(--linx-colors-gray-400)`,
        color: `hsl(0 0% 98.2%)`,
      },
    },
    gray: {
      bgColor: `var(--linx-colors-gray-700)`,
      color: `var(--linx-colors-brand-light)`,
      _hover: {
        boxShadow: `var(--linx-elevation-_hover)`,
        bgColor: `hsl(200 96.6% 41.5%)`,
        color: `hsl(0 0% 88.2%)`,
      },
      _active: {
        bgColor: `hsl(200 96.6% 36.9%)`,
        color: `hsl(0 0% 88.2%)`,
      },
      _disabled: {
        bgColor: `var(--linx-colors-gray-400)`,
        color: `hsl(0 0% 98.2%)`,
      },
    },
    plain: {
      bgColor: `var(--linx-colors-transparent)`,
      color: `var(--linx-colors-brand-light)`,
      _hover: {
        bgColor: `hsl(0 0% 100% / 0.1)`,
      },
      _active: {
        bgColor: `hsl(200 96.6% 36.9%)`,
        color: `hsl(200 96.6% 36.9%)`,
      },
      _disabled: {
        bgColor: `var(--linx-colors-gray-400)`,
        color: `hsl(0 0% 98.2%)`,
      },
    },
    baseStyle: {
      paddingInlineStart: `var(--linx-space-24)`,
      paddingInlineEnd: `var(--linx-space-24)`,
      gap: `var(--linx-space-8)`,
    },
  },
  Heading: {
    baseStyle: {
      md: `500 16px/1.25 var(--font-nunito), Nunito, sans-serif`,
      sm: `400 14px/1.25 var(--font-nunito), Nunito, sans-serif`,
    },
  },
};

export type ComponentsTheme = typeof components;

export const prefix = `linx`;

export const basePxFontSize = 16;
